import { Component, OnInit } from '@angular/core';
// import * as AOS from 'aos';


@Component({
  selector: 'app-crm-privacy-policy',
  templateUrl: './crm-privacy-policy.component.html',
  styleUrls: ['./crm-privacy-policy.component.scss']
})
export class CrmPrivacyPolicyComponent    {

}